
import { defineComponent } from "vue";
import SalesOrderDraftOrderOverview from "@/views/sales-order/draft-orders/CommonOverview.vue";
import DoubleSaleOrderOrderDraftOrderOverview from "./CommonOverview.vue";

export default defineComponent({
  name: "double-sales-order-draft-order-overview",
  components: {
    // SalesOrderDraftOrderOverview,
    DoubleSaleOrderOrderDraftOrderOverview,
  },
});
